import Loadable from '../../components/loadable';

const UpcomingCreditConflictsModal = Loadable({
  loader: () => import('../../pages/memberships/upcoming_credit_conflicts_modal'),
  type: 'modal',
});

angular.module('gym').value('UpcomingCreditConflictsModal', UpcomingCreditConflictsModal);
